import Vue from 'vue';
import Router from 'vue-router';
import ls from 'local-storage';


// lazy loading
const EnvioAvulso = () =>
    import ('./../components/envio/EnvioAvulso.vue');
const UploadArquivo = () =>
    import ('./../components/envio/UploadArquivo.vue');

const Recarga = () =>
    import ('./../components/recarga/Home.vue');
const MinhasRecargas = () =>
    import ('./../components/recarga/MinhasRecargas.vue');
const AssinaturaLembraZap = () =>
    import ('./../components/recarga/AssinaturaLembraZap.vue');

const Login = () =>
    import ('./../components/auth/Login.vue');
const ResetSenha = () =>
    import ('./../components/auth/ResetSenha.vue');

const AgendaContato = () =>
    import ('./../components/agendaContato/Home.vue');
const EditAgenda = () =>
    import ('./../components/agendaContato/EditAgenda.vue');

const NaoConfiavelHome = () =>
    import ('./../components/naoConfiavel/Home.vue');

const Mensagens = () =>
    import ('./../components/mensagens/Home.vue');

const MeuPerfil = () =>
    import ('./../components/meuPerfil/Home.vue');
const DadosApi = () =>
    import ('./../components/meuPerfil/DadosApi.vue');

const Retornos = () =>
    import ('./../components/relatorios/retornos/Home.vue');
const ConsultaCelular = () =>
    import ('./../components/relatorios/consultaCelular/Home.vue');
const RelatorioEspecializado = () =>
    import ('./../components/relatorios/especializado/Home.vue');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: '/',
  linkExactActiveClass: 'active',
  routes: [
    // envios
    {
      path: '',
      component: {
        render(c) { return c('router-view'); }, // then I dont need a parent component file
      },
      meta: {
        humanName: 'Envio de mensagens',
        showOnNav: true,
      },
      children: [
        // agenda
        {
          path: '/envioAvulso',
          name: 'EnvioAvulso',
          component: EnvioAvulso,
          meta: {
            humanName: 'Envio avulso',
            pathAlias: 'Envios > Envio Avulso',
            showOnNav: true,
          },
        },
        {
          path: '/uploadArquivo',
          name: 'UploadArquivo',
          component: UploadArquivo,
          meta: {
            humanName: 'Upload de arquivo',
            pathAlias: 'Envios > Upload de arquivo',
            showOnNav: true,
          },
        },
      ],
    },

    // register
    {
      path: '/register',
      name: 'Register',
      component: Login,
      meta: {
        humanName: 'Cadastrar-me',
        pathAlias: 'Cadastrar-me',
        showOnNav: false,
      },
    },
    // MeuPerfil
    {
      path: '/meuPerfil',
      name: 'MeuPerfil',
      component: MeuPerfil,
      meta: {
        humanName: 'Meu perfil',
        pathAlias: 'Meu perfil',
        showOnNav: false,
      },
    },
    // Dados Documentação
    {
      path: '/dadosApi',
      name: 'DadosApi',
      component: DadosApi,
      meta: {
        humanName: 'Dados API',
        pathAlias: 'Dados API',
        showOnNav: false,
      },
    },
    // login
    {
      path: '/login',
      name: 'Login',
      props: true,
      component: Login,
      meta: {
        humanName: 'Login',
        pathAlias: 'Users > Login',
      },
    },
    // reset senha
    {
      path: '/reset-senha',
      name: 'ResetSenha',
      component: ResetSenha,
      meta: {
        humanName: 'Resetar senha',
        pathAlias: 'Users > reset',
      },
    },

    // cadastros
    {
      path: '',
      component: {
        render(c) { return c('router-view'); }, // then I dont need a parent component file
      },
      meta: {
        humanName: 'Cadastros',
        showOnNav: true,
      },
      children: [
        // agenda
        {
          path: '/agendaContato',
          name: 'AgendaContato',
          component: AgendaContato,
          meta: {
            humanName: 'Agendas de contatos',
            pathAlias: 'Agendas de contato > Minhas Agendas',
            showOnNav: true,
            icon: 'fa-address-book',
            clickable: true,
          },
        },
        {
          path: '/editAgenda/:id',
          name: 'EditAgenda',
          component: EditAgenda,
          meta: {
            humanName: 'Agendas de contatos',
            pathAlias: 'Agendas de contato > Editar agenda',
          },
        },

        // numeros nao confiaveis
        {
          path: '/blacklists',
          name: 'NaoConfiavel',
          component: NaoConfiavelHome,
          meta: {
            humanName: 'Blacklists',
            pathAlias: 'Blacklists',
            showOnNav: true,
            icon: 'fa-ban',
            clickable: true,
          },
        },

        // mensagens
        {
          path: '/mensagens',
          name: 'Mensagens',
          component: Mensagens,
          meta: {
            humanName: 'Mensagens pré cadastradas',
            pathAlias: 'Mensagens pré cadastradas > Lista',
            showOnNav: true,
            icon: 'fa-list',
            clickable: true,
          },
        },
      ],
    },

    // relatorios
    {
      path: '/relatorios',
      component: {
        render(c) { return c('router-view'); }, // / then I dont need a parent component file
      },
      meta: {
        humanName: 'Relatórios',
        showOnNav: true,
      },
      children: [{
        path: '/consultaCelular',
        name: 'ConsultaCelular',
        component: ConsultaCelular,
        meta: {
          humanName: 'Consulta celular',
          pathAlias: 'Relatórios > Consulta celular',
          showOnNav: true,
        },
      },
      {
        path: '/retornos',
        name: 'Retornos',
        component: Retornos,
        meta: {
          humanName: 'Retornos',
          pathAlias: 'Relatórios > Retornos de clientes',
          showOnNav: true,
        },
      },
      {
        path: '/especializado',
        name: 'RelatorioEspecializado',
        component: RelatorioEspecializado,
        meta: {
          humanName: 'Especializado',
          pathAlias: 'Relatórios > Especializado',
          showOnNav: true,
        },
      },
      ],
    },

    // recargas
    {
      path: '/recargas',
      component: {
        render(c) { return c('router-view'); }, // / then I dont need a parent component file
      },
      meta: {
        humanName: 'Recargas',
        showOnNav: true,
        icon: 'fa-plane',
        clickable: false,
      },
      children: [{
        path: '',
        name: 'Nova recarga',
        component: Recarga,
        meta: {
          humanName: 'Nova recarga',
          pathAlias: 'Recargas > Nova recarga',
          showOnNav: true,
        },
      },
      {
        path: 'minhasRecargas',
        props: true, // pass paramas as props, then you dont need to use $watch
        name: 'MinhasRecargas',
        component: MinhasRecargas,
        meta: {
          humanName: 'Minhas Recargas',
          pathAlias: 'Recargas > Minhas Recargas',
          showOnNav: true,
        },
      },
      {
        path: 'AssinaturaLembraZap',
        props: true, // pass paramas as props, then you dont need to use $watch
        name: 'AssinaturaLembraZap',
        component: AssinaturaLembraZap,
        meta: {
          humanName: 'Assinatura LembraZap',
          pathAlias: 'Recargas > Assinatura LembraZap',
          showOnNav: true,
        },
      },
      ],
    },

    { path: '*', component: EnvioAvulso, meta: {} },
  ],
});

router.beforeEach((to, from, next) => {
  const searchParams = new URLSearchParams(window.location.search);
  const tokenByUrl = searchParams.get('token');

  if (tokenByUrl) {
    ls('token', tokenByUrl);
    window.location.href = '/recargas';
  }

  const token = ls('token');
  if (!token && (to.name !== 'Login' && to.name !== 'Register' && to.name !== 'ResetSenha')) {
    next('/login');
  } else {
    next();
  }
});

export default router;
